import { ErrorBase } from "./base.error";
import { ErrorName } from "./errors";

export class ItecError extends ErrorBase<ErrorName> {}
